import { Component, input, output } from '@angular/core';
import {
  BatchUploadConfig,
  BatchUploadModalComponent,
} from '@shared/components/batch-upload-modal/batch-upload-modal.component';

@Component({
  selector: 'app-batch-upload-creative-status',
  imports: [BatchUploadModalComponent],
  template: `
    <app-batch-upload-modal
      [isVisible]="isVisible()"
      [config]="uploadConfig"
      (isVisibleChange)="isVisibleChange.emit($event)"
    ></app-batch-upload-modal>
  `,
})
export class BatchUploadCreativeStatusComponent {
  readonly isVisible = input<boolean>(false);
  readonly isVisibleChange = output<boolean>();

  uploadConfig: BatchUploadConfig = {
    title: '批量修改创意状态',
    templateUrl:
      'https://static-cdn.linkworld.cn/xiaohong/红品智-推广-批量修改创意状态模板_2026-10-30.xlsx',
    type: 17,
    description: '1、下载批量修改创意状态模板，批量填写创意状态信息',
  };
}
